module.exports = __webpack_public_path__ + "img/regis_d.7d7e1e7a.png";